<div mat-dialog class="no-rounded-card create-company-dialog" [attr.aria-hidden]="false">
	<button type="button" class="pay-create-company-close-btn btn btn-secondary btn-icon-dark d-flex justify-content-between round p-3" (click)="closeDialog()">
		<app-keenicon name="cross" type="solid" class="fs-2"></app-keenicon>
	</button>
	<div class="row h-100">
		<div class="pay-rwd-col-title col-12 col-sm-12 col-md-4 col-xl-3 bg-primary p-0 h-100">
			<div class="h-50">
				<h1 class="page-heading text-white fw-bold fs-2hx p-20" translate>create_a_company</h1>
			</div>
			<div class="h-50 pay-create-company-bg"></div>
		</div>
		<div class="pay-rwd-col-form col-12 col-sm-12 col-md-8 col-xl-9 bg-light-light p-0">
			<div class="p-20 mt-20">
				<div class="pb-10 pb-lg-15">
					<h2 class="fw-bolder text-gray-900" translate>create_company_information</h2>
					<div class="text-gray-500 fw-400 fs-6 w-50" translate>create_company_information_description</div>
				</div>
				<div [formGroup]="form">
					<div class="row">
						<div class="col-12 col-sm-6 mb-10 fv-row">
							<label for="company-name" class="form-label mb-3 required" translate>create_company_form_label_name</label>
							<input
								id="company-name"
								formControlName="name"
								type="text"
								class="form-control form-control-lg form-control-solid"
								placeholder="{{ 'create_company_form_label_name_placeholder' | translate }}"
							/>
							<div *ngIf="form.get('name')?.hasError('required') && form.get('name')?.touched" class="fv-plugins-message-container invalid-feedback" translate>
								create_company_form_label_name_error
							</div>
						</div>
						<div class="col-12 col-sm-6 mb-10 fv-row">
							<label for="company-legal-name" class="form-label mb-3 required" translate>create_company_form_label_legal_name</label>
							<input
								id="company-legal-name"
								formControlName="legalName"
								type="text"
								class="form-control form-control-lg form-control-solid"
								placeholder="{{ 'create_company_form_label_legal_name_placeholder' | translate }}"
							/>
							<div *ngIf="form.get('legalName')?.hasError('required') && form.get('legalName')?.touched" class="fv-plugins-message-container invalid-feedback" translate>
								create_company_form_label_legal_name_error
							</div>
						</div>
						<div class="col-12 col-sm-6 mb-10 fv-row">
							<label for="company-vat" class="form-label mb-3 required" translate>create_company_form_label_vat</label>
							<input
								id="company-vat"
								formControlName="vat"
								type="text"
								class="form-control form-control-lg form-control-solid"
								placeholder="{{ 'create_company_form_label_vat_placeholder' | translate }}"
							/>
							<div *ngIf="form.get('vat')?.hasError('required') && form.get('vat')?.touched" class="fv-plugins-message-container invalid-feedback" translate>
								create_company_form_label_vat_error
							</div>
						</div>
						<div class="col-12 col-sm-6 mb-10 fv-row">
							<label for="company-email" class="form-label mb-3 required" translate>create_company_form_label_email</label>
							<input
								id="company-email"
								formControlName="email"
								type="text"
								class="form-control form-control-lg form-control-solid"
								placeholder="{{ 'create_company_form_label_email_placeholder' | translate }}"
							/>
							<div *ngIf="form.get('email')?.hasError('email') && form.get('email')?.touched" class="fv-plugins-message-container invalid-feedback" translate>
								create_company_form_label_email_error
							</div>
						</div>
						<div class="col-12 col-sm-6 mb-10 fv-row">
							<label for="company-city" class="form-label mb-3" translate>create_company_form_label_city</label>
							<input
								id="company-city"
								formControlName="addressCity"
								type="text"
								class="form-control form-control-lg form-control-solid"
								placeholder="{{ 'create_company_form_label_city_placeholder' | translate }}"
							/>
						</div>
						<div class="col-12 col-sm-6 mb-10 fv-row">
							<label for="company-country" class="form-label mb-3" translate>create_company_form_label_country</label>
							<input
								id="company-country"
								formControlName="addressCountry"
								type="text"
								class="form-control form-control-lg form-control-solid"
								placeholder="{{ 'create_company_form_label_country_placeholder' | translate }}"
							/>
						</div>
						<div class="col-12 col-sm-9 mb-10 fv-row">
							<label for="company-address" class="form-label mb-3" translate>create_company_form_label_address</label>
							<input
								id="company-address"
								formControlName="address"
								type="text"
								class="form-control form-control-lg form-control-solid"
								placeholder="{{ 'create_company_form_label_address_placeholder' | translate }}"
							/>
						</div>
						<div class="col-12 col-sm-3 mb-10 fv-row">
							<label for="company-zipcode" class="form-label mb-3" translate>create_company_form_label_zipcode</label>
							<input
								id="company-zipcode"
								formControlName="addressZipCode"
								type="text"
								class="form-control form-control-lg form-control-solid"
								placeholder="{{ 'create_company_form_label_zipcode_placeholder' | translate }}"
							/>
						</div>
						<div class="col-12 col-sm-6 mb-10 fv-row">
							<label for="company-phone" class="form-label mb-3" translate>create_company_form_label_phone</label>
							<input
								id="company-phone"
								formControlName="phone"
								type="text"
								class="form-control form-control-lg form-control-solid"
								placeholder="{{ 'create_company_form_label_phone_placeholder' | translate }}"
							/>
						</div>
						<div class="col-12 col-sm-6 mb-10 fv-row">
							<label for="company-website" class="form-label mb-3" translate>create_company_form_label_website</label>
							<input
								id="company-website"
								formControlName="website"
								type="text"
								class="form-control form-control-lg form-control-solid"
								placeholder="{{ 'create_company_form_label_website_placeholder' | translate }}"
							/>
						</div>
					</div>
					<div class="d-flex justify-content-end pt-10 mb-5">
						<button
							type="submit"
							(click)="createACompany()"
							class="hover-elevate-up d-flex align-items-center justify-content-center btn btn-primary btn-hover-primary rounded font-weight-bolder px-8 py-4"
						>
							<span class="text-white font-size-sm me-2" translate>create_company_save_company</span>
							<app-keenicon name="rocket" class="fs-3 text-white"></app-keenicon>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
